import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { axiosPrivate } from '../../api/axios';
import { secondsToHms } from '../../utils/time';
import arrow from '../../assets/arrow_outward.png'
import dr15_2 from "../../assets/dr15_2.png";

interface Assessment {
    _id: string;
    title: string;
    thumbnail: string;
    duration: number;
    resultId:string,
}

const MainContent = () => {
    const [assessment, setAssessment] = useState<Assessment[]>([]);
    const [completedAssessments, setCompletedAssessments] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 6;
    // const [tab, setTab] = useState('new');
    const user = JSON.parse(localStorage.getItem('user') as string);
    const userId = user?.id || user?._id;

    React.useEffect(() => {
        (async () => {
            await axiosPrivate.get('/assessment/frontend').then((resp) => {
                if (user?.isB2COTU) {
                    setAssessment(
                        resp.data?.filter((a: any) =>
                            user?.priviligedAssessments?.includes(a?._id)
                        )
                    );
                } else {
                    setAssessment(resp.data);
                }
            });
        })();
    }, [userId]);

    React.useEffect(() => {
        (async () => {
            await axiosPrivate.get(`/assessment/${userId}/all`).then((resp) => {
                setCompletedAssessments(resp.data);
            });
        })();
    }, [userId]);

    const totalPages = Math.ceil(completedAssessments.length / itemsPerPage);
    const paginatedAssessments = completedAssessments.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const styles = {
        bottomBg: {
            position: "fixed" as const,
            top: "10%",
            left: 0,
            bottom: 0,
            width: "100%",
            height: "auto",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "bottom center",
            backgroundImage: `url(${dr15_2})`,
            zIndex: -4,
        }
    }
    return (
        <>
            <section className="dasboard-content lg:w-[calc(100%-15rem)] bg-gray-sm min-h-[calc(100vh-104px)] sm:px-6 px-3 sm:py-7 py-4">
                <div className="w-full flex justify-start items-start mt-4 pb-6 mb-5">
                    {/* Welcome Text */}
                    <div className="flex flex-col gap-2 w-full">
                        <span className="font-bold text-[24px] text-[#141414]" style={{ fontFamily: '"Inter", sans-serif' }}>Hello, User! 👋</span>
                        <span className="font-medium text-[12px] text-[#989ca0]" style={{ fontFamily: '"Inter", sans-serif' }}>
                            Welcome back, track your team progress here!
                        </span>
                    </div>
                </div>
                <h3 className="md:text-2xl sm:text-xl text-base text-gray-black font-medium sm:mb-4 mb-2" style={{ fontFamily: '"Inter", sans-serif' }}>
                    Completed Assessments
                </h3>
                <div className="flex flex-wrap sm:-mx-3">
                    {/* Cards Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 w-full sm:px-3 px-2">
                        {paginatedAssessments?.map((a: Assessment, idx: number) => (
                            <div
                                key={idx}
                                className="bg-white p-4 rounded-xl border border-gray-300 drop-shadow-lg flex flex-col items-start justify-between min-h-[400px]"
                                style={{ boxShadow: "0px 32px 26px rgba(0, 0, 0, 0.05)" }}
                            >
                                {/* Image */}
                                <div className="w-full h-40">
                                    <img
                                        className="w-full h-full object-cover rounded-t-xl"
                                        src={a.thumbnail}
                                        alt={a.title}
                                    />
                                </div>

                                {/* Title & Duration */}
                                <div className="w-full flex flex-col items-start px-4 py-3 flex-grow">
                                    <h4 className="text-lg font-semibold text-gray-900 mb-2" style={{ fontFamily: '"Inter", sans-serif' }}>
                                        {a.title}
                                    </h4>
                                    <span className="flex items-center text-gray-600 text-sm" style={{ fontFamily: '"Inter", sans-serif' }}>
                                        ⏳ {secondsToHms(a.duration)}
                                    </span>
                                </div>

                                {/* Button */}
                                <Link
                                    to={`/assessments/result?resultId=${a?.resultId}`}
                                    className="flex items-center gap-2 w-full sm:w-fit px-4 py-2 border border-[#1e2a32] text-white font-medium text-sm rounded-md bg-[#1e2a32] hover:bg-[#14202a] transition"
                                >
                                    <img src={arrow} alt="Arrow" className="h-3 w-3" />
                                    <span style={{ fontFamily: '"Inter", sans-serif' }}>See Result</span>
                                </Link>
                            </div>
                        ))}
                    </div>

                    {/* Pagination Controls - Centered and Fixed Position */}
                    <div className="w-full flex justify-center items-center mt-6">
                        <div className="flex flex-wrap items-center gap-2 px-4 py-2 bg-white">
                            {/* Page Numbers */}
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                <button
                                    key={page}
                                    className={`px-3 py-2 text-sm font-medium border rounded-md ${currentPage === page
                                            ? "bg-[#1e2a32] text-white border-[#1e2a32]"
                                            : "text-gray-700 hover:bg-gray-200 border-gray-400"
                                        }`}
                                    onClick={() => setCurrentPage(page)}
                                    style={{ fontFamily: '"Inter", sans-serif' }}
                                >
                                    {page}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                <div style={styles.bottomBg}></div>
            </section>
        </>
    );
};

export default MainContent;
